import React, { useEffect, useState } from "react";
import "./admincontrols.css";

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  // Load config.json first
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_TOTAL_ORDERS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setOrders(data.orders);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
        setLoading(false);
      });
  }, [config]);

  return (
    <div className="orders-page">
      <h2>Total Orders</h2>
      {loading ? (
        <p>Loading orders...</p>
      ) : orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <table className="orders-table">
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Address</th>
              <th>Product Name</th>
              <th>Price</th>
              <th>Delivered Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td>{order.customer_name}</td>
                <td>{order.email}</td>
                <td>{order.mobilenumber}</td>
                <td>{order.address}</td>
                <td>{order.product_name}</td>
                <td>{order.price}</td>
                <td>{order.delivered_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrdersPage;
